import React from 'react';
import { styled } from '../styles';
const colorAlpha1 = 'rgb(0,0,0,0.15) 25%';
const colorAlpha2 = 'rgb(0,0,0,0.15) 75%';
// const ImagePixelContentChildren = "../fdsa.png"

const Root = styled('div')(() => ({
  flex: '1 0 auto',
  display: 'block',
  backgroundImage: "linear-gradient(45deg, ".concat(colorAlpha1, ", transparent 25%), linear-gradient(-45deg, ").concat(colorAlpha1, ", transparent 15%), linear-gradient(45deg, transparent 75%, ").concat(colorAlpha2, "), linear-gradient(-45deg, transparent 75%, ").concat(colorAlpha2, ")"),
  backgroundSize: '10px 10px',
  backgroundPosition: '0 0, 10px 0, 10px -10px, 0px 10px'
}));
const PixelContentMock = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(Root, null, children);
};
export default PixelContentMock;